<template>
  <div class="ranking-container">
    <!-- 标题栏 -->
    <header class="mq-header">
      <span class="back-icon" @click="goBack">&lt;</span>
      <h1 class="mq-title">排行榜</h1>
      <div class="header-spacer"></div>
    </header>

    <!-- 主要内容区 -->
    <main class="ranking-main">
      <!-- 时间选择区域 -->
      <div class="ranking-tabs">
        <button 
          v-for="time in timeOptions" 
          :key="time.value"
          @click="selectTime(time.value)"
          class="tab-item"
          :class="{ active: selectedTime === time.value }"
        >
          {{ time.label }}
        </button>
      </div>

      <!-- 排行榜列表 -->
      <div class="ranking-content">
        <template v-if="rankingData && rankingData.length">
          <div class="top-three-container">
            <div class="rank-item-second">
              <div class="rank-badge rank-2">
                <i class="fas fa-medal"></i>
              </div>
              <p class="rank-nickname">
                {{ rankingData[1]?.nickname || '暂无' }}
              </p>
              <p class="rank-score">
                {{ rankingData[1]?.score || 0 }}题
              </p>
            </div>
            <div class="rank-item-first">
              <div class="rank-badge rank-1">
                <i class="fas fa-trophy"></i>
              </div>
              <p class="rank-nickname rank-first">
                {{ rankingData[0]?.nickname || '暂无' }}
              </p>
              <p class="rank-score rank-first-score">
                {{ rankingData[0]?.score || 0 }}题
              </p>
            </div>
            <div class="rank-item-third">
              <div class="rank-badge rank-3">
                <i class="fas fa-award"></i>
              </div>
              <p class="rank-nickname">
                {{ rankingData[2]?.nickname || '暂无' }}
              </p>
              <p class="rank-score">
                {{ rankingData[2]?.score || 0 }}题
              </p>
            </div>
          </div>

          <div class="ranking-list" @scroll="onScroll" style="max-height: 400px; overflow-y: auto;">
            <div 
              v-for="(item, index) in rankingData.slice(3)" 
              :key="index"
              class="ranking-item"
            >
              <div class="rank-number">
                {{ item.rank }}
              </div>
              <div class="rank-info">
                <p class="rank-name">
                  {{ item.nickname }}
                </p>
                <p class="rank-date">
                  {{ item.date }}
                </p>
              </div>
              <p class="rank-score-item">
                {{ item.score }}题
              </p>
            </div>
            
            <!-- 加载状态 -->
            <div v-if="loading" class="loading-state">
              <p class="loading-text">正在加载...</p>
            </div>
            
            <!-- 到底了提示 -->
            <div v-else-if="!hasMore && rankingData.length > 0" class="end-state">
              <p class="end-text">到底了</p>
            </div>
          </div>
        </template>
        <div v-else class="empty-state">
          <p class="empty-text">暂无排行数据</p>
        </div>
      </div>

      <!-- 排行榜操作按钮 -->
      <div class="bottom-actions">
        <button 
          @click="startChallenge" 
          class="start-btn"
        >
          <i class="fas fa-flag-checkered"></i>
          开始挑战
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import { getRank } from '@/api/api'
export default {
  name: 'RankingPage',
  data() {
    return {
      selectedTime: '5',
      timeOptions: [
        {
          value: '5',
          label: '5分钟'
        },
        {
          value: '10',
          label: '10分钟'
        },
        {
          value: '15',
          label: '15分钟'
        }
      ],
      rankingData: [],
      currentPage: 1,
      pageSize: 10,
      loading: false,
      hasMore: true
    }
  },
  mounted() {
    this.fetchRank();
  },
  methods: {
    selectTime(timeValue) {
      this.selectedTime = timeValue;
      // 重置分页状态
      this.currentPage = 1;
      this.rankingData = [];
      this.hasMore = true;
      this.fetchRank();
    },
    fetchRank() {
      if (this.loading || !this.hasMore) return;
      
      this.loading = true;
      
      getRank({
        time: this.selectedTime,
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        const list = res && res.data.data || [];
        
        if (list.length > 0) {
          const newData = list.map((item, idx) => ({
            rank: item.rank || ((this.currentPage - 1) * this.pageSize + idx + 1),
            nickname: item.nickname || item.name || '匿名',
            score: item.total_score / 10,
            date: item.date || item.createdAt || ''
          }));
          
          // 第一页时保存完整数据
          if (this.currentPage === 1) {
            this.rankingData = newData;
          } else {
            // 后续页直接追加
            this.rankingData = [...this.rankingData, ...newData];
          }
          
          // 检查是否还有更多数据
          this.hasMore = list.length === this.pageSize;
          this.currentPage++;
        } else {
          this.hasMore = false;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 下拉加载更多
    loadMore() {
      this.fetchRank();
    },
    // 滚动事件处理
    onScroll(event) {
      const target = event.target;
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;
      
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.loading && this.hasMore) {
        this.loadMore();
      }
    },
    goBack() {
      this.$router.push('/');
    },
    startChallenge() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.start-btn {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 8px;
  background: #D54D24;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.transition-custom {
  transition: all 0.3s ease;
}

.rank-1 {
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
}

.rank-2 {
  background: linear-gradient(135deg, #C0C0C0 0%, #A9A9A9 100%);
}

.rank-3 {
  background: linear-gradient(135deg, #CD7F32 0%, #D2B48C 100%);
}

.ranking-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F5F5;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.mq-header {
  background: url('@/assets/top.png') no-repeat center center;
  background-size: cover;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 40px 20px 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: row;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  min-height: 70px;
}

.back-icon {
  font-size: 20px;
  margin-right: 20px;
  cursor: pointer;
  color: #fff;
}

.back-icon i {
  color: #fff;
  font-size: 16px;
}

.mq-title {
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}

.header-spacer {
  width: 40px;
}

.ranking-main {
  flex: 1;
  padding: 100px 24px 24px 24px;
}

.ranking-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  background-color: white;
  border-radius: 12px;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-item {
  flex: 1;
  padding: 12px 16px;
  text-align: center;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  background: none;
}

.tab-item.active {
  background-color: #D54D24;
  color: white;
  box-shadow: 0 2px 4px rgba(213, 77, 36, 0.3);
}

.tab-item:not(.active) {
  color: #666666;
}

.tab-item:not(.active):hover {
  background-color: #F3F4F6;
}

.ranking-list {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 32px;
}

.ranking-item {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #F3F4F6;
  transition: background-color 0.3s ease;
}

.ranking-item:last-child {
  border-bottom: none;
}

.ranking-item:hover {
  background-color: #F9FAFB;
}

.ranking-item.top-1 {
  background: linear-gradient(135deg, #FFF5F0 0%, #FFE8E0 100%);
}

.ranking-item.top-2 {
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
}

.ranking-item.top-3 {
  background: linear-gradient(135deg, #FEFCE8 0%, #FEF3C7 100%);
}

.ranking-rank {
  width: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #666666;
}

.ranking-rank.top-3 {
  color: #D54D24;
  font-size: 24px;
}

.ranking-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 16px;
  object-fit: cover;
  border: 2px solid #E5E7EB;
}

.ranking-avatar.top-1 {
  border-color: #D54D24;
  box-shadow: 0 0 0 2px rgba(213, 77, 36, 0.2);
}

.ranking-avatar.top-2 {
  border-color: #9CA3AF;
}

.ranking-avatar.top-3 {
  border-color: #D97706;
}

.ranking-info {
  flex: 1;
}

.ranking-name {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 4px;
}

.ranking-name.top-3 {
  font-weight: bold;
  color: #D54D24;
}

.ranking-time {
  font-size: 12px;
  color: #999999;
}

.ranking-score {
  font-size: 20px;
  font-weight: bold;
  color: #D54D24;
  margin-right: 16px;
}

.ranking-score.top-3 {
  font-size: 24px;
}

.ranking-trophy {
  color: #D97706;
  font-size: 24px;
}

.ranking-trophy.top-1 {
  color: #D54D24;
}

.ranking-trophy.top-2 {
  color: #9CA3AF;
}

.empty-state {
  text-align: center;
  padding: 60px 24px;
  color: #999999;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-text {
  font-size: 16px;
  margin-bottom: 24px;
}

.start-challenge-btn {
  background-color: #D54D24;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.start-challenge-btn:hover {
  background-color: #C2410C;
}

.bottom-actions {
  text-align: center;
  margin-top: 32px;
}

.start-challenge-bottom {
  background-color: #D54D24;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 48px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.start-challenge-bottom:hover {
  background-color: #C2410C;
}
.ranking-content {
  text-align: center;
  margin-bottom: 24px;
}

.ranking-subtitle {
  color: #666666;
  font-size: 14px;
  margin-bottom: 16px;
}

.top-three-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
  min-height: 120px;
}

.rank-item-first,
.rank-item-second,
.rank-item-third {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33.333%;
  min-height: 100px;
}

.rank-badge {
  color: white;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.rank-badge.rank-1 {
  width: 40px;
  height: 40px;
  font-size: 14px;
}

.rank-badge.rank-2,
.rank-badge.rank-3 {
  width: 32px;
  height: 32px;
  font-size: 12px;
}

.rank-nickname {
  color: #333333;
  font-size: 14px;
  margin-bottom: 2px;
}

.rank-nickname.rank-first {
  font-weight: bold;
  font-size: 16px;
}

.rank-score {
  color: #D54D24;
  font-weight: bold;
  font-size: 14px;
}

.rank-score.rank-first-score {
  font-size: 18px;
}

.ranking-list {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.ranking-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #F3F4F6;
  transition: background-color 0.3s ease;
}

.ranking-item:last-child {
  border-bottom: none;
}

.ranking-item:hover {
  background-color: #F9FAFB;
}

.rank-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #9CA3AF;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-right: 12px;
}

.rank-info {
  flex: 1;
  text-align: left;
}

.rank-name {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}

.rank-date {
  color: #999999;
  font-size: 12px;
}

.rank-score-item {
  color: #D54D24;
  font-weight: bold;
  font-size: 14px;
}

.loading-state {
  padding: 20px;
  text-align: center;
  color: #666666;
  font-size: 14px;
}

.loading-text {
  margin: 0;
}

.end-state {
  padding: 20px;
  text-align: center;
  color: #999999;
  font-size: 14px;
}

.end-text {
  margin: 0;
}

.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  background-color: rgba(245, 245, 245, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  text-align: center;
  z-index: 10;
}

.ranking-main {
  padding-bottom: 120px; /* 为固定按钮留出空间 */
}
</style>